module.exports = __webpack_public_path__ + "img/GRAND_THEATER.7002c185.png";